export interface TextSegment {
  readonly text: string;
  readonly isMatch: boolean;
}

// Base sensitivity ignores case and accents, as the server's name search
// does: "ali" finds "Álison", "lodz" finds "Łódź".
const baseLetterCollator = new Intl.Collator(undefined, {
  sensitivity: "base",
});

function findWordRanges(
  text: string,
  word: string,
): readonly (readonly [number, number])[] {
  const ranges: (readonly [number, number])[] = [];
  for (let start = 0; start + word.length <= text.length; start += 1) {
    const end = start + word.length;
    if (baseLetterCollator.compare(text.slice(start, end), word) === 0) {
      ranges.push([start, end]);
    }
  }
  return ranges;
}

export function splitByQueryMatches(
  text: string,
  query: string,
): readonly TextSegment[] {
  const ranges = query
    .split(/\s+/u)
    .filter((word) => word !== "")
    .flatMap((word) => findWordRanges(text, word))
    .sort(([startA], [startB]) => startA - startB);

  const segments: TextSegment[] = [];
  let cursor = 0;
  let matchStart: number | null = null;
  for (const [start, end] of ranges) {
    if (matchStart !== null && start > cursor) {
      segments.push({ text: text.slice(matchStart, cursor), isMatch: true });
      matchStart = null;
    }
    if (matchStart === null) {
      if (start > cursor) {
        segments.push({ text: text.slice(cursor, start), isMatch: false });
      }
      matchStart = start;
    }
    cursor = Math.max(cursor, end);
  }
  if (matchStart !== null) {
    segments.push({ text: text.slice(matchStart, cursor), isMatch: true });
  }
  if (cursor < text.length) {
    segments.push({ text: text.slice(cursor), isMatch: false });
  }
  return segments;
}
